import { Injectable } from '@angular/core';
import { PolicyApiService } from '@modules/private/admin/popups-manager/pages/policy-popup/services/policy.api.service';

@Injectable({
  providedIn: 'root'
})
export class CheckPolicyService {
  constructor(private apiService: PolicyApiService) {}

  checkHasNewPolicy(userId: number) {
    return this.apiService.checkUserHasNewPolicy(userId);
  }
}
